<template>
  <div class="relative">
    <button
      v-if="compact"
      @click="open = !open"
      class="group flex flex-col items-center justify-center gap-1 w-[68px] py-2 rounded-md transition-all duration-200 ease-out active:scale-95 text-ink2 hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--muted))/60]"
    >
      <Globe class="w-5 h-5" :stroke-width="1.7" />
      <span class="text-[10px] leading-none font-medium">{{ currentOption?.short }}</span>
    </button>
    <button
      v-else
      @click="open = !open"
      class="flex items-center gap-1.5 text-[12px] font-semibold text-ink2 hover:text-[hsl(var(--foreground))] transition-colors"
    >
      <Globe class="w-3.5 h-3.5" />
      {{ currentOption?.short }}
    </button>

    <Transition name="lang-pop">
      <div
        v-if="open"
        class="absolute w-16 rounded-md border border-border bg-sheet shadow-ink overflow-hidden py-1 z-50"
        :class="openDown ? 'top-full right-0 mt-1.5' : 'bottom-full left-0 mb-1.5'"
      >
        <button
          v-for="opt in OPTIONS"
          :key="opt.code"
          @click="select(opt.code)"
          :title="opt.label"
          class="w-full text-left px-3 py-1.5 text-[13px] font-semibold transition-colors"
          :class="opt.code === locale
            ? 'text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)]'
            : 'text-[hsl(var(--foreground))] hover:bg-[hsl(var(--muted)/0.5)]'"
        >{{ opt.short }}</button>
      </div>
    </Transition>

    <div v-if="open" class="fixed inset-0 z-40" @click="open = false" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Globe } from "lucide-vue-next";
import { type SupportedLocale } from "../i18n";
import { changeLocale } from "../analytics";

defineProps<{ compact?: boolean; openDown?: boolean }>();

const { locale } = useI18n();
const open = ref(false);

const OPTIONS: Array<{ code: SupportedLocale; label: string; short: string }> = [
  { code: "kk", label: "Қазақша", short: "Qaz" },
  { code: "ru", label: "Русский", short: "Рус" },
  { code: "en", label: "English", short: "Eng" },
];

const currentOption = computed(() => OPTIONS.find((o) => o.code === locale.value) || OPTIONS[0]);

const select = (code: SupportedLocale) => {
  changeLocale(code);
  open.value = false;
};
</script>

<style scoped>
.lang-pop-enter-active, .lang-pop-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.lang-pop-enter-from, .lang-pop-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>
